import Api from '../core/Api'
import Offline from './Offline'
import Distributeur from './Distributeur'
import User from './User'
import OperationBouteille from "./OperationBouteille"
import Fluide from "./Fluide";
import Fibsdd from "./Fibsdd";
import Transporteur from "./Transporteur";
import Detenteur from "./Detenteur";
import swal from "sweetalert2";
import distributeur from "./Distributeur";
import scan from "@/js/models/Scan";
import localforage from "localforage";

class Bouteille {

    static addBouteille(data) {

        return new Promise((resolve, reject) => {

            data.actif = true;
            data.restitution = false;

            if (data.fluide === 0) {
                delete data['fluide']
            }

            this
                .addBouteilleOffline(data)
                .then(result => resolve(result))
                .catch(err => reject(err))

        })

    }

    static getAllScanByBouteilles(boutId) {

        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .get('/scans')
                        .then(result => {
                            let scans = result.data.scans;

                            scans = _.filter(scans, scan => {
                                if(scan.bouteille.id === parseInt(boutId)){
                                    localforage.getItem('listUsers').then(usrs => {
                                        let lstUsrs = JSON.parse(usrs);

                                        if (lstUsrs) {
                                            lstUsrs.filter(usr => {
                                                if (usr.id === scan.user.id) {
                                                    scan.user = usr.nom
                                                }
                                            })
                                        }

                                    });

                                    return scan;
                                }
                            })

                            resolve(scans)
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static addBouteilleOnline(data) {

        return new Promise((resolve, reject) => {

            Api
                .init()
                .then(api => {

                    api
                        .post('/bouteille', data)
                        .then(result => {

                            if (!result.data.hasOwnProperty('errors')) {
                                resolve(result.data)
                            } else {
                                reject(result.data.errors)
                            }

                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        })
    }

    static updateOnline(id, data) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {

                    api
                        .put('/bouteille/' + id, data)
                        .then(res => {
                            if (!res.data.hasOwnProperty('errors')) {
                                resolve(res.data)
                            } else {
                                let errs = {
                                    apiMsg: res.data.errors,
                                    payload: data
                                };
                                reject(errs)
                            }

                        })
                        .catch(err => {
                            if(err.response.status === 403 || err.response.status === 404){
                                resolve(true)
                            } else {
                                reject(err)
                            }

                        })


                })
                .catch(err => reject(err))

        })

    }

    static addBouteilleOffline(data) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(list => {

                    let newKey = 'N-' + +new Date();
                    data.id = newKey;
                    list.push(data);

                    localforage
                        .setItem('listBouteilles', JSON.stringify(list))
                        .then(() => {

                            Offline.saveAction({
                                action: 'add',
                                type: 'Bouteille',
                                id: newKey
                            });

                            resolve(newKey)

                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    static updateBouteille(id, data) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(lstBouteilles => {

                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }

                    let index = _.findIndex(lstBouteilles, ['id', id]);
                    lstBouteilles[index] = data;

                    localforage
                        .setItem('listBouteilles', JSON.stringify(lstBouteilles))
                        .then(() => {

                            if (!_.includes(id, 'N-')) {
                                Offline.saveAction({
                                    type: 'Bouteille',
                                    action: 'update',
                                    id: id
                                })
                            }
                            resolve('Update ok')
                        })
                        .catch(() => reject('erreur upadte'))

                })
                .catch(err => reject(err))

        })

    }

    static serialize(data) {
        let payload = {};

        payload.code = data.code;
        payload.type = data.type;
        payload.actif = data.actif;

        let dateRetourPrevue = moment(data.date_retour_prevue);
        if (dateRetourPrevue.year() < 1000) {
            dateRetourPrevue = moment()
        }

        let dateLivraison = moment(data.date_livraison);
        if (dateLivraison.year() < 1000) {
            dateLivraison = moment()
        }

        payload.dateRetourPrevue = dateRetourPrevue.format('YYYY-MM-DD');
        payload.dateLivraison = dateLivraison.format('YYYY-MM-DD');
        payload.refLivraison = data.ref_livraison;
        payload.poidsNet = data.poids_net;
        payload.poidsMax = data.poids_max;
        payload.tare = data.tare;
        payload.fournisseur = data.fournisseur.id;
        payload.nom = data.nom.id;
        payload.createdAt = data.created_at;

        if (data.key1 && data.key2) {
            payload.otag = data.key1 + '-' + data.key2;
        }

        if(data.otag){
            payload.otag = data.otag
        }

        if (data.hasOwnProperty('annexe')) {
            payload.annexe = data.annexe
        }

        if(data.hasOwnProperty('transporteurs')) {
            payload.transporteurs = data.transporteurs;
        }

        if (data.hasOwnProperty('fluide') && data.fluide !== null && data.fluide.hasOwnProperty('id')) {
            payload.fluide = data.fluide.id
        }

        if (data.hasOwnProperty('distributeur_retour_id')) {
            payload.distributeurRetour = data.distributeur_retour_id
        }

        if(data.hasOwnProperty('favori') && data.favori !== null && data.favori.hasOwnProperty('id')) {
            payload.favori = {
                'id': data.favori.id,
            }
        }

        payload.restitution = data.restitution;

        return payload

    }

    static applyOperation(op) {

        return new Promise((resolve, reject) => {

            this
                .getBouteille(op.id_bouteille)
                .then(bouteille => {

                    let pdsActuel = bouteille.poids_net;
                    let pdsOp = op.quantite;
                    pdsActuel = Number.parseFloat(pdsActuel);
                    pdsOp = Number.parseFloat(pdsOp);

                    let inverse = _.includes(op.type.toLowerCase(), 'régularisation');
                    if (_.includes(op.type.toLowerCase(), 'ajout')) {
                        if (inverse) {
                            bouteille.poids_net = round(pdsActuel + pdsOp, 3)
                        } else {
                            bouteille.poids_net = round(pdsActuel - pdsOp, 3)
                        }
                    } else {
                        if (inverse) {
                            bouteille.poids_net = round(pdsActuel - pdsOp, 3)
                        } else {
                            bouteille.poids_net = round(pdsActuel + pdsOp, 3)
                        }
                    }

                    if (!bouteille.hasOwnProperty('fluide') || _.isEmpty(bouteille.fluide)) {

                        let fluideObj = new Fluide;

                        fluideObj.getFluide(op.id_fluide, res => {

                            bouteille.fluide = res;

                            Bouteille
                                .updateBouteille(op.id_bouteille, bouteille)
                                .then(data => resolve(data))
                                .catch(err => reject(err))

                        })

                    } else {

                        if(bouteille.type !== 'Fluide frigorigène' && bouteille.poids_net === 0){
                            bouteille.fluide = null;
                        }

                        Bouteille
                            .updateBouteille(op.id_bouteille, bouteille)
                            .then(data => resolve(data))
                            .catch(err => reject(err))

                    }

                })
                .catch(err => reject(err))

        })

    }

    static rollbackOperation(op) {
        return new Promise((resolve, reject) => {
            Bouteille
                .getBouteille(op.id_bouteille)
                .then(bouteille => {

                    let pdsActuel = bouteille.poids_net;
                    let pdsOp = op.quantite;
                    pdsActuel = Number.parseFloat(pdsActuel);
                    pdsOp = Number.parseFloat(pdsOp);

                    if (_.includes(op.type, 'Ajout')) {

                        bouteille.poids_net = round(pdsActuel + pdsOp, 3);

                    } else {

                        bouteille.poids_net = round(pdsActuel - pdsOp, 3);

                        if (parseInt(bouteille.poids_net) === 0 && bouteille.type !== 'Fluide frigorigène') {
                            delete bouteille.fluide;
                        }
                    }

                    Bouteille
                        .updateBouteille(op.id_bouteille, bouteille)
                        .then(() => resolve(op.id))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    static close(id, bouteille) {

        swal({
            title: "Êtes-vous sûr ?",
            text: "Vous ne pourrez plus effectuer d'opérations sur cette bouteille.",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
        }).then(() => {

            bouteille.actif = false;
            Bouteille
                .updateBouteille(id, bouteille)
                .then()
                .catch();

            swal('Bouteille clôturée !', "Vous ne pouvez plus réaliser d'opérations sur cette bouteille", 'success')

        })
            .catch()

    }

    static async canClose(id){

        let bout = await Bouteille.getBouteille(id);

        let fermable = true;

        if(bout.poids_net !== 0){

            let opObj = new OperationBouteille();

            await opObj.getOpsForBouteille(id).then(ops => {
                for(let op of ops){
                    if(op.type.includes('réutilisation')){
                        fermable = false
                    }
                }
            })

        }
        return fermable

    }

    static async getDetenteurIsOk(id) {

        let opsObj = new OperationBouteille();
        let operations = await opsObj.getList();

        let isOk = {'isOk' : true, 'detId' : [], 'detNom' : []};

        let ops = operations.filter(o => o.id_bouteille === id);
        for (const op of ops) {
            if(op.id_detenteur !== null && op.id_type === 4){

                let det = await Detenteur.getDetenteurWithAsync(op.id_detenteur);

                //C'est un string, donc laissé comme ça :)
                if(det.siret == null && det.type == "Société"){

                    if(!_.includes(isOk.detId, det.id)) {
                        isOk.isOk = false;
                        isOk.detId.push(det.id);
                        isOk.detNom.push(det.raison_sociale);
                    }


                    return isOk;
                }
            }
        }

        return false;
    }

    static async isFluidFrigo(id){

        let bout = await Bouteille.getBouteille(id);


        if(bout.type === 'Fluide frigorigène'){
            return true;
        }

        return false;
    }

    static async isReutilisable(id){

        let bout = await Bouteille.getBouteille(id);


        let reutilisable = false;

        if(bout.poids_net !== 0){

            let opObj = new OperationBouteille();

            /**
             * Type opération :)
             * 1 - Ajout fluide vierge
             * 2 - Ajout fluide recyclé
             * 3 - Ajout fluide régénéré
             * 4 - Retrait fluide pour traitement
             * 5 - Retrait fluide pour réutilisation
             * 6 - Régul "Ajout"
             * 7 - Régul "Retrait"
             */

            let tempCalc = 0;
            await opObj.getOpsForBouteille(id).then(ops => {
                for(let op of ops){

                    if(op.id_type === 1 || op.id_type === 2 || op.id_type === 3 || op.id_type === 6){
                        tempCalc = round(tempCalc - op.quantite, 3);
                    }else{
                        tempCalc = round(tempCalc + op.quantite, 3);
                    }

                    if(op.type.includes('réutilisation')){
                        reutilisable = true;
                    }

                    if(tempCalc === bout.poids_net){
                        return reutilisable;
                    }
                }
            })

        }

        return reutilisable
    }

    static askAddBouteille() {

        User
            .getUserData(data => {

                let html = '';

                if (!data.admin) {
                    html += '<a class="btn addbouteille" onclick="swal(\'Attention\',\'Contactez un administrateur pour un ajout bouteille depuis le backoffice.\',\'success\')" href="javascript: void 0" id="nopuce">JE N\'AI PAS DE PUCE</a>';
                }
                html += '<a class="btn addbouteille" onclick="swal.closeModal()" href="fi360://scan?success=tryGoTo" ><i class="icon-otag" style="left: 131px;font-size: 29px;"></i>SCAN OTAG</a>';

                if (data.admin) {
                    html += '<a class="btn addbouteille" onclick="swal.closeModal()" href="#/new-bouteille">AJOUTER SANS PUCE</a>';
                }

                swal({
                    title: 'Ajout bouteille',
                    showConfirmButton: false,
                    html
                })

            })

    }

    static clotureBouteille(id) {

        return new Promise((resolve, reject) => {

            this
                .getBouteille(id)
                .then(bout => {

                    bout.actif = false;

                    this
                        .updateBouteille(id, bout)
                        .then(() => resolve('Bouteille clôturée'))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        })

    }

    static setNumeroAnnexe(id, str) {

        return new Promise((resolve, reject) => {

            this
                .getBouteille(id)
                .then(bout => {

                    bout.annexe = str;

                    this
                        .updateBouteille(id, bout)
                        .then(() => resolve('Numero annexe 1 attribué'))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    static confirmRestitution(ids, isReutilisable = false) {

        return new Promise((resolve, reject) => {
            let msg;
            let title = 'Êtes-vous sûr ?';
            if (ids.length === 1) {
                msg = "La bouteille sera archivée."
            } else {
                msg = "Confirmer la restitution de " + ids.length + " bouteilles ?"
            }

            let isActivateTD = (localStorage.getItem('activateTrackDechets') === 'true');

            if(isReutilisable === true && isActivateTD === true) {
                title = 'Bouteille pour réutilisation';
                msg = "Attention Bouteille contenant du Fluide pour <strong>réutilisation</strong>.<br> Elle ne peut être rendue en l'état sur <strong>TRACKDECHETS</strong>";
                swal({
                    title: title,
                    html: msg,
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Ok',
                    showConfirmButton: false,
                    allowOutsideClick: false
                })
                    .catch(() => reject('Bouteille contenant du fluide pour réutilisation, elle ne peut pas être rendue'))
            }else{
                swal({
                    title: title,
                    html: msg,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Non',
                    allowOutsideClick: false,
                })
                    .then(() => resolve(ids))
                    .catch(() => reject('Pas de confirmation'))
            }


        })

    }

    static choiceDistributeurRetour(ids, isReutilisable = false, isFluidFrigo = false) {

        return new Promise((resolve, reject) => {

            Distributeur
                .getList()
                .then(data => {

                    if(data.length === 0){
                        swal('Aucun site de retour', "Vous n'avez renseigné aucun site ou ils sont non conforme trackdéchets, vous pouvez les ajouter depuis l'interface d'administration", 'error').then(reject('Aucun site de retour disponible'));
                    } else {
                        let dists = {};


                        if(isReutilisable === true || isFluidFrigo === true || localStorage.getItem('activateTrackDechets') === 'false'){
                            _.forEach(data, val => {
                                if (true === val.actif) {
                                    dists[val.id] = val.raison_sociale + ' - ' + val.ville
                                }
                            });
                        }else{
                            _.forEach(data, val => {
                                if (true === val.actif && val.is_visible_by_td === true) {
                                    dists[val.id] = val.raison_sociale + ' - ' + val.ville
                                }
                            });
                        }


                        if(_.size(dists) === 0){
                            return swal('Aucun site de retour', "Les sites de retour ne sont pas conforme, vous pouvez les corriger depuis l'interface d'administration", 'error').then(reject('Aucun site de retour disponible'));
                        }

                        swal({
                            title: 'Site de retour',
                            input: 'select',
                            inputOptions: dists,
                            showCancelButton: true,
                            confirmButtonText: 'Oui',
                            cancelButtonText: 'Annuler',
                            allowOutsideClick: false
                        })
                            .then(res => {
                                if (!_.includes(res, 'N-')) {
                                    res = parseInt(res)
                                }

                                let distChosen = _.find(data, ['id', res]);

                                if (distChosen.hasOwnProperty('email') && distChosen.email) {
                                    swal({

                                        title: 'Envoyer un mail au site de retour ?',
                                        text: '( ' + distChosen.email + ' )',
                                        confirmButtonText: 'Oui',
                                        cancelButtonText: 'Non',
                                        allowOutsideClick: false,
                                        showCancelButton: true

                                    }).then(
                                        function () {

                                            resolve({
                                                dist: parseInt(res),
                                                sendMail: true,
                                                ids: ids
                                            })

                                        },
                                        function () {

                                            resolve({
                                                dist: parseInt(res),
                                                sendMail: false,
                                                ids: ids
                                            })

                                        }
                                    );

                                } else {

                                    resolve({
                                        dist: parseInt(res),
                                        sendMail: false,
                                        ids: ids
                                    })

                                }


                            })
                            .catch(err => reject(err))

                    }

                })
                .catch(err => reject(err))

        })

    }

    static async createRecapPopup(txt) {
        return new Promise((resolve, reject) => {
            swal({
                title: 'Récapitulatif',
                html: txt,
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                allowOutsideClick: false
            }).then(
                //Oui
                () => {
                    resolve(true);
                },

                //Non
                () => {
                    reject('canceled');
                }
            )
        })

    }

    static async createRecap(transporteur, bouteilles, siteDeRetour) {
        return new Promise((resolve, reject) => {

            if(typeof transporteur === "undefined" || typeof bouteilles === "undefined"){
                reject('Erreur lors de la création du récapitulatif');
            }

            let thisMessage = `Vous êtes sur le point de rendre : <br>${bouteilles.join('')}</strong><br> ${transporteur}<br>Au site de retour :<br> <strong>${siteDeRetour}</strong><br> Confirmez-vous ?`;

            resolve(thisMessage);
        })
    }

    static choiceTransporteur(isReutilisable = false, isFluidFrigo = false) {
        return new Promise((resolve, reject) => {

            let isOperateurTransporteur = (localStorage.getItem('hasTransporterTd') === 'true');
            let isActivateTD = (localStorage.getItem('activateTrackDechets') === 'true');

            if(isActivateTD == false){
                resolve({
                    transporteurs: 0
                })
            }

            if(isReutilisable === true || isFluidFrigo === true){
                resolve({
                    transporteurs: 0
                })
            }

            Transporteur
                .getList()
                .then(data => {

                    //Active TD
                    if(isActivateTD == true) {

                        if(isOperateurTransporteur == true) {
                            swal({
                                title: 'Transporteur',
                                html: 'Je dépose moi-même la bouteille ? <span class="question-info more_info" title="Répondre OUI si c\'est vous qui déposez la bouteille chez votre distributeur.\nRépondre NON si c\'est un transporteur qui enlèvera la bouteille.">Aide</span>',
                                type: 'question',
                                showCancelButton: true,
                                confirmButtonText: 'Oui',
                                cancelButtonText: 'Non',
                                allowOutsideClick: false,
                            }).then(

                                /*
                                async () => {

                                    await User.getUserData(user => {
                                        if(user.immatriculation == null || user.immatriculation === ''){
                                            swal({
                                                title: 'Aucune immatriculation',
                                                html: 'Vous n\'avez pas renseigné votre immatriculation <br> <input type="text" title="Plaque immatriculation" class="" id="licensePlate" placeholder="XX-XXX-XX">',
                                                type: "info",
                                                allowOutsideClick: false,
                                                showCancelButton: true,
                                                confirmButtonText: 'Valider',
                                                cancelButtonText: 'Annuler',
                                            }).then(() => {
                                                let licensePlate = document.getElementById('licensePlate').value;

                                                if(licensePlate === null || licensePlate === "") {
                                                    swal({
                                                        title: 'Aucune immatriculation',
                                                        text: 'Vous n\'avez pas renseigné votre immatriculation, elle est obligatoire sur TrackDéchets',
                                                        type: "error",
                                                        allowOutsideClick: true,
                                                    }).then(() => {
                                                        reject('Aucune immatriculation')
                                                    })
                                                }else{

                                                    user.immatriculation = licensePlate;

                                                    let userInstance = new User;
                                                    userInstance.updateUser(user)
                                                    resolve({ transporteurs: 0 })

                                                }
                                            })
                                        }
                                    })
                                 */

                                //Oui
                                () => {
                                    resolve({
                                        transporteurs: 0
                                    })
                                },
                                //Non

                                () => {
                                    let transporteurs = {};

                                    _.forEach(data, val => {
                                        if(val.actif && val.is_visible_by_td == true) {
                                            transporteurs[val.id] = val.raison_sociale
                                        }
                                    })


                                    if(_.size(transporteurs) === 0) {
                                        swal({
                                            title: 'Aucun Transporteurs',
                                            text: 'Vous n\'avez pas de transporteurs actifs',
                                            type: "error",
                                            allowOutsideClick: false,
                                        }).then(() => {
                                            reject('Aucun transporteurs actifs')
                                        })
                                    }else{
                                        swal({
                                            title: 'Transporteur',
                                            text: 'Choisissez le transporteur',
                                            input: 'select',
                                            inputOptions: transporteurs,
                                            showCancelButton: true,
                                            confirmButtonText: 'Valider',
                                            cancelButtonText: 'Annuler',
                                            allowOutsideClick: false,
                                        }).then(

                                            (res) => {
                                                if (!_.includes(res, 'N-')) {
                                                    res = parseInt(res);
                                                }

                                                resolve({
                                                    transporteurs: parseInt(res)
                                                })
                                            },

                                            () => reject('Annulation')
                                        ).catch(err => reject(err))
                                    }


                                }

                            ).catch(err => reject(err))

                        }else{
                            //Pas Transporter
                            let transporteurs = {};

                            if(localStorage.getItem('activateTrackDechets') === 'false'){
                                _.forEach(data, val => {
                                    if(val.actif) {
                                        transporteurs[val.id] = val.raison_sociale
                                    }
                                })
                            }else{
                                _.forEach(data, val => {
                                    if(val.actif && val.is_visible_by_td == true) {
                                        transporteurs[val.id] = val.raison_sociale
                                    }
                                })
                            }

                            if(_.size(transporteurs) === 0) {
                                swal({
                                    title: 'Aucun Transporteurs',
                                    text: 'Vous n\'avez pas de transporteurs actifs',
                                    type: "error",
                                    allowOutsideClick: false,
                                }).then(() => {
                                    reject('Aucun transporteurs actifs')
                                })
                            }else{
                                swal({
                                    title: 'Transporteur',
                                    text: 'Choisissez le transporteur',
                                    input: 'select',
                                    inputOptions: transporteurs,
                                    showCancelButton: true,
                                    confirmButtonText: 'Valider',
                                    cancelButtonText: 'Annuler',
                                    allowOutsideClick: false,
                                }).then(

                                    (res) => {
                                        if (!_.includes(res, 'N-')) {
                                            res = parseInt(res);
                                        }

                                        resolve({
                                            transporteurs: parseInt(res)
                                        })
                                    },

                                    () => reject('Annulation')
                                ).catch(err => reject(err))
                            }

                        }

                    } else {
                        //Pas TD
                        //Osef bloqué au dessus
                    }


                })
                .catch(err => reject(err))
        })
    }

    static async restitution(ids, isReutilisable = false, isFluidFrigo = false) {
        await this.confirmRestitution(ids, isReutilisable);

        let getTransporteur = await this.choiceTransporteur(isReutilisable, isFluidFrigo);
        let res = await this.choiceDistributeurRetour(ids, isReutilisable, isFluidFrigo);
        let getDistributeur = await Distributeur.getDistributeur(res.dist);
        let distributeurString = getDistributeur.raison_sociale;
        distributeurString = distributeurString.replace(getDistributeur.ville, '');
        distributeurString = distributeurString + " " + getDistributeur.code_postal + " " + getDistributeur.ville;
        let transporteurString = "Vous êtes le transporteur";
        let bouteilleString = [];
        let isFirstBouteille = true;

        for (let idBout of res.ids) {
            let bouteilleObj = await Bouteille.getBouteille(idBout);
            let stringBt = '';
            if(bouteilleObj.otag != null) {
                if(isFirstBouteille) {
                    stringBt += 'Bouteille: <strong>';
                    isFirstBouteille = false;
                }
                stringBt += ' ' + bouteilleObj.code + ' <span style="font-size: 13px">O-tag:</span> ' + bouteilleObj.otag;
            }else{
                if(isFirstBouteille) {
                    stringBt = 'Bouteille: <strong>';
                    isFirstBouteille = false;
                }
                stringBt += ' ' + bouteilleObj.code;
            }

            if(stringBt !== '') {
                bouteilleString.push(stringBt);
            }
        }

        if(getTransporteur.transporteurs !== 0) {
            transporteurString = await Transporteur.getTransporteur(getTransporteur.transporteurs);
            transporteurString = "Le transporteur est : <strong>" + transporteurString.raison_sociale + "</strong>";
        }



        let recapString = await this.createRecap(transporteurString, bouteilleString, distributeurString);

        await this.createRecapPopup(recapString);

        let bouteilles = res.ids;
        let transporteur = getTransporteur.transporteurs;
        let idDist = res.dist;
        let sendMail = res.sendMail;

        await Offline.saveAction({
            action: 'add',
            type: 'restitutionBouteille',
            sendMail: sendMail,
            distributeur: idDist,
            bouteilles: bouteilles,
            transporteur: transporteur
        });

        for (const idBout of bouteilles) {

            let bouteille = await Bouteille.getBouteille(idBout);
            bouteille.restitution = true;
            bouteille.distributeur_retour_id = idDist;
            bouteille.transporteurs = transporteur;
            await Bouteille.updateBouteille(bouteille.id, bouteille);

        }
    }

    static getBouteille(id) {

        return new Promise((resolve, reject) => {

            Bouteille
                .getList()
                .then(data => {

                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }

                    let bouteille = _.find(data, ['id', id]);

                    if (bouteille) {
                        resolve(bouteille)
                    } else {
                        reject('Bouteille inexistante')
                    }

                })
                .catch('Erreur lors du get list')

        })

    }

    static getBouteilleByTag(key1, key2) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {

                    let bouteille = _.find(data, {
                        key1,
                        key2
                    });

                    let boutByOtag = _.find(data, {
                        'otag': key1 + '-' + key2
                    });

                    if (bouteille) {
                        resolve(bouteille);
                    } else if (boutByOtag) {
                        resolve(boutByOtag);
                    } else {
                        reject("Tag non utilisé sur les bouteille stockées sur l'appareil");
                    }

                })
                .catch(err => reject(err))

        })

    }

    static getList() {

        return new Promise((resolve, reject) => {

            localforage
                .getItem('listBouteilles')
                .then(bouteilles => {
                    resolve(JSON.parse(bouteilles))
                })
                .catch(error => {
                    reject(error)
                })

        })
    }

    static getErrorsBouteille() {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {

                    let filtred = _.filter(data, bouteille => {
                        let dateRetour = moment(bouteille.date_retour_prevue);
                        let today = moment();
                        let diff = today.diff(dateRetour, 'days', true);

                        if (diff > 0) {
                            bouteille.type_notif = "error";
                            bouteille.diff = diff;
                            return bouteille
                        }
                    });

                    if (filtred) {
                        resolve(filtred)
                    } else {
                        reject('Aucune notif bouteille')
                    }

                })
                .catch(err => reject(err))

        })

    }

    static getWarningsBouteille() {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {

                    let filtred = _.filter(data, bouteille => {
                        let dateRetour = moment(bouteille.date_retour_prevue);
                        let today = moment();
                        let diff = today.diff(dateRetour, 'days', true);

                        if (diff > -7 && diff < 0) {
                            bouteille.type_notif = "warning";
                            bouteille.diff = diff;
                            return bouteille
                        }
                    });

                    if (filtred) {
                        resolve(filtred)
                    } else {
                        reject('Aucune notif bouteille')
                    }

                })
                .catch(err => reject(err))
        })


    }

    static async checkTdProblem(id) {

        let opsObj = new OperationBouteille();

        if (!_.includes(id, 'N-')) {
            id = parseInt(id);
        }

        let problems = [];

        const operations = await opsObj.getList();

        let ops = operations.filter(o => o.id_bouteille === id && o.id_type === 4);

        for (const op of ops) {
            console.log('op', op);
            let detenteur = await Detenteur.getDetenteur(op.id_detenteur)

            if(detenteur.type === "Société" && (detenteur.siret === null || detenteur.siret === "")) {
                problems.push(" " + detenteur.raison_sociale + " (" + detenteur.ville + ")");
            }
        }

        return problems;
    }


    static async isRendable(id) {

        let opsObj = new OperationBouteille();

        if (!_.includes(id, 'N-')) {
            id = parseInt(id)
        }

        const bouteille = await Bouteille.getBouteille(id);
        const operations = await opsObj.getList();

        if (bouteille.actif === false && bouteille.restitution === false) {

            let ops = operations.filter(o => o.id_bouteille === id);
            let fiObj = new Fibsdd();

            for (const op of ops) {
                let fi = await fiObj.getFibsdd(op.id_fibsdd);
                if (fi) {
                    if (fi.cloture === false) {
                        return false
                    }

                }

            }

            // FIN DU CHECK
            return true

        } else {

            return false

        }

    }

}

export default Bouteille



// WEBPACK FOOTER //
// ./src/js/models/Bouteille.js